/*

  https://fontawesome.com/docs/web/use-with/react/

 */

export { default } from "./icon";
